export default {"src":"/_next/static/media/unhide-small-icon-mobile.43d5bdf1.svg","height":8,"width":13};